var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDocumentPage = function SvgDocumentPage(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e8e5fe;}.cls-2{fill:#8075f2;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "document-page") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "budicon-document-page"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.5,1H19V18.5a.5.5,0,0,1-.5.5H4v1.5a.5.5,0,0,0,.5.5h16a.5.5,0,0,0,.5-.5V1.5A.5.5,0,0,0,20.5,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23,4V22.5a.5.5,0,0,1-.5.5H7v1H24V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.5,3H22V1.5A1.5,1.5,0,0,0,20.5,0H4.5A1.5,1.5,0,0,0,3,1.5v19A1.5,1.5,0,0,0,4.5,22H6v1.5A1.5,1.5,0,0,0,7.5,25h16A1.5,1.5,0,0,0,25,23.5V4.5A1.5,1.5,0,0,0,23.5,3ZM4,20.5V1.5A.5.5,0,0,1,4.5,1h16a.5.5,0,0,1,.5.5v19a.5.5,0,0,1-.5.5H4.5A.5.5,0,0,1,4,20.5Zm20,3a.5.5,0,0,1-.5.5H7.5a.5.5,0,0,1-.5-.5V22H20.5A1.5,1.5,0,0,0,22,20.5V4h1.5a.5.5,0,0,1,.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.5,8H10a.5.5,0,0,0,0-1H6.5a.5.5,0,0,0,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.5,5H10a.5.5,0,0,0,0-1H6.5a.5.5,0,0,0,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.5,11H10a.5.5,0,0,0,0-1H6.5a.5.5,0,0,0,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.5,13H6.5a.5.5,0,0,0,0,1h12a.5.5,0,0,0,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.5,16H6.5a.5.5,0,0,0,0,1h12a.5.5,0,0,0,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18,4H14a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V5A1,1,0,0,0,18,4Zm0,6H14V5h4Z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentPage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/document-page.3a6ce9bb5b2cff4dc04e3dc54736bb72.svg";